<template>
  <div class="team-report-description-page">
    <i18n-t keypath="pdfReport.descpage_heading" :locale="lang" tag="h2"></i18n-t>
    <div class="description-box">
      <i18n-t keypath="pdfReport.leadership_style" :locale="lang" class="top-heading first" tag="div"></i18n-t>
      <div class="preserving">
        <i18n-t keypath="pdfReport.preserving_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-left-wrapper">
          <div class="desc-text">
            <i18n-t keypath="pdfReport.preserving_desc" :locale="lang" tag="p"></i18n-t>
          </div>
        </div>
      </div>
      <div class="changing">
        <i18n-t keypath="pdfReport.changing_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.changing_desc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <i18n-t keypath="pdfReport.objective" :locale="lang" class="top-heading first" tag="div"></i18n-t>
      <div class="continuity">
        <i18n-t keypath="pdfReport.preserving_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.preserving_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <div class="innovative">
        <i18n-t keypath="pdfReport.changing_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.changing_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
    </div>
    <div class="description-box">
      <i18n-t keypath="pdfReport.leadership_style" :locale="lang" class="top-heading second" tag="div"></i18n-t>
      <div class="independent">
        <i18n-t keypath="pdfReport.independent_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-left-wrapper">
          <div class="desc-text">
            <i18n-t keypath="pdfReport.independent_desc" :locale="lang" tag="p"></i18n-t>
          </div>
        </div>
      </div>
      <div class="relation-oriented">
        <i18n-t keypath="pdfReport.relationoriented_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.relationoriented_desc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <i18n-t keypath="pdfReport.objective" :locale="lang" class="top-heading second" tag="div"></i18n-t>
      <div class="task-focus">
        <i18n-t keypath="pdfReport.independent_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.independent_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <div class="good-relations">
        <i18n-t keypath="pdfReport.relationoriented_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.relationoriented_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
    </div>

    <div class="description-box">
      <i18n-t keypath="pdfReport.leadership_style" :locale="lang" class="top-heading third" tag="div"></i18n-t>
      <div class="flexible">
        <i18n-t keypath="pdfReport.flexible_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-left-wrapper">
          <div class="desc-text">
            <i18n-t keypath="pdfReport.flexible_desc" :locale="lang" tag="p"></i18n-t>
          </div>
        </div>
      </div>
      <div class="structured">
        <i18n-t keypath="pdfReport.structured_heading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.structured_desc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <i18n-t keypath="pdfReport.objective" :locale="lang" class="top-heading third" tag="div"></i18n-t>
      <div class="adaptability">
        <i18n-t keypath="pdfReport.flexible_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.flexible_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
      <div class="coordination">
        <i18n-t keypath="pdfReport.structured_subheading" :locale="lang" class="desc-heading" tag="div"></i18n-t>
        <div class="desc-text">
          <i18n-t keypath="pdfReport.structured_subdesc" :locale="lang" tag="p"></i18n-t>
        </div>
      </div>
    </div>

    <table class="manager-params">
      <thead>
        <tr>
          <i18n-t keypath="pdfReport.manager_params" :locale="lang" tag="th"></i18n-t>
          <i18n-t keypath="pdfReport.low_value" :locale="lang" tag="th"></i18n-t>
          <i18n-t keypath="pdfReport.high_value" :locale="lang" tag="th"></i18n-t>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><i18n-t keypath="pdfReport.decisiveness" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.decisiveness_low_subheading" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.decisiveness_high_subheading" :locale="lang" tag="p"></i18n-t></td>
        </tr>
        <tr>
          <td><i18n-t keypath="pdfReport.socialimpact" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.socialimpact_low_subheading" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.socialimpact_high_subheading" :locale="lang" tag="p"></i18n-t></td>
        </tr>
        <tr>
          <td><i18n-t keypath="pdfReport.stressmanagement" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.stressmanagement_low_subheading" :locale="lang" tag="p"></i18n-t></td>
          <td><i18n-t keypath="pdfReport.stressmanagement_high_subheading" :locale="lang" tag="p"></i18n-t></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    lang: ''
  }
}
</script>

<style scoped>
* {
  letter-spacing: initial!important;
}
h2 {
  font-size: 20px!important;
  margin: 0 0 15px 0!important;
  padding: 0!important;
  color: #000000;
  width: 450px;
}
h3 {
  font-size: 14px!important;
  margin: 12px 0 6px 0!important;
  padding: 0!important;
  color: #000000;
}
p,
p strong {
  font-size: 9px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
}
.team-report-description-page {
  padding: 0 60px;
}
.description-box {
    display: flex;
    width: 460px;
    flex-wrap: wrap;
    margin-bottom: 17px;
}

.preserving,
.changing {
    border-left: 0.5pt solid #0069b4;
    width: 230px;
}
.changing,
.innovative {
    border-right: 0.5pt solid #0069b4;
}
.preserving .desc-heading,
.changing .desc-heading,
.continuity .desc-heading,
.innovative .desc-heading {
    background-color: #0069b4;
}
.continuity,
.innovative {
    border-left: 0.5pt solid #0069b4;
    border-bottom: 0.5pt solid #0069b4;
    width: 230px;
}

.independent,
.relation-oriented {
    border-left: 0.5pt solid #7761a7;
    width: 230px;
}
.relation-oriented,
.good-relations {
    border-right: 0.5pt solid #7761a7;
}
.independent .desc-heading,
.relation-oriented .desc-heading,
.task-focus .desc-heading,
.good-relations .desc-heading {
    background-color: #7761a7;
}
.task-focus,
.good-relations {
    border-left: 0.5pt solid #7761a7;
    border-bottom: 0.5pt solid #7761a7;
    width: 230px;
}

.flexible,
.structured {
    border-left: 0.5pt solid #4fa8b1;
    width: 230px;
}
.structured,
.coordination {
    border-right: 0.5pt solid #4fa8b1;
}
.flexible .desc-heading,
.structured .desc-heading,
.adaptability .desc-heading,
.coordination .desc-heading {
    background-color: #4fa8b1;
}
.adaptability,
.coordination {
    border-left: 0.5pt solid #4fa8b1;
    border-bottom: 0.5pt solid #4fa8b1;
    width: 230px;
}

.manager-params th {
    color: #ffffff;
    font-size: 10px;
    padding: 0 6px 3px 6px;
    background-color: #8c8c8c;
}
.manager-params td {
    background-color: #ffffff;
    padding: 4px 6px;
}
.manager-params td:first-child {
    background-color: #e8e8e8;
}
.manager-params td:last-child {
    border-left: 0.5pt solid #8c8c8c;
}
.manager-params {
    width: 460px;
    border: 0.5pt solid #8c8c8c;
}

.desc-left-wrapper {
    position: relative;
    display: flex;
}
.desc-text {
    padding: 3px 6px;
}
.desc-heading {
  white-space: nowrap;
  color: #ffffff;
  font-size: 10px;
  padding: 0 6px 3px 6px;
}

.top-heading {
    position: relative;
    width: 460px;
    background-color: #cce1f0;
    padding: 2px 6px;
    font-size: 9px;
}
.top-heading.first {
    border-top: 0.5pt solid #0069b4;
    border-left: 0.5pt solid #0069b4;
    border-right: 0.5pt solid #0069b4;
}
.top-heading.second {
    border-top: 0.5pt solid #7761a7;
    border-left: 0.5pt solid #7761a7;
    border-right: 0.5pt solid #7761a7;
}
.top-heading.third {
    border-top: 0.5pt solid #4fa8b1;
    border-left: 0.5pt solid #4fa8b1;
    border-right: 0.5pt solid #4fa8b1;
}

/* Firefox specifics */
@supports (-moz-appearance:none) {
  .description-box {
    margin-bottom: 10px;
  }
}
</style>
